import { useRef } from "react";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../../../../../store/action/loadingAction";
import { getTemporaryBlockId, processChangeCard } from "../../../../../../../services/helpers/Helper";
import { uploadImage } from "../../../../../../../services/upload/Upload";
import { setError } from "../../../../../../../store/action/errorAction";
import SlateEditor from "../../../../SlateEditor/editor";
import Button from "./button";

const GalleryItem = (props) => {
   const { onChange, index, faqId, image, card } = props;
   let { data } = props;
   const ref = useRef();
   const dispatch = useDispatch();

   const handleClickUpload = () => {
      ref.current.click();
   }

   const onChangeFile = (e) => {
      const file = e.target.files[0];
      if (file) {
         dispatch(showLoading());
         uploadImage(file).then((response) => {
            if (onChange) {
               data = processChangeCard(data, {
                  ...card,
                  images: card.images.map((m, i) => i === index ? { ...image, image_url: response.data } : m)
               }, faqId);
               onChange(data);
            }
         }).catch((error) => {
            dispatch(setError(error.message));
         }).finally(() => {
            dispatch(hideLoading());
         });
      }
   }

   const onChangeTitle = (string) => {
      if (onChange) {
         data = processChangeCard(data, {
            ...card,
            images: card.images.map((m, i) => i === index ? { ...image, title: string } : m)
         }, faqId);
         onChange(data);
      }
   }

   const onChangeSubTitle = (string) => {
      if (onChange) {
         data = processChangeCard(data, {
            ...card,
            images: card.images.map((m, i) => i === index ? { ...image, sub_title: string } : m)
         }, faqId);
         onChange(data);
      }
   }

   const getImage = () => {
      return image?.image_url
   }

   const handleAddButton = () => {
      if (onChange) {
         data = processChangeCard(data, {
            ...card,
            images: card.images.map((m, i) => i === index ? { ...image, buttons: [...image.buttons, { title: 'Nút #' + (image.buttons.length + 1) }] } : m)
         }, faqId);
         onChange(data);
      }
   }

   const handleChangeButton = (buttons) => {
      if (onChange) {
         data = processChangeCard(data, {
            ...card,
            images: card.images.map((m, i) => i === index ? { ...image, buttons } : m)
         }, faqId);
         onChange(data);
      }
   }

   return (
      <div className="card-gallery-item-wrapper">
         <div className="card-gallery-item-container">
            <div className="card-gallery-item animated">
               <div className="card-gallery-item-content" style={{ paddingBottom: 30 }}>
                  <div className="input-file" onClick={handleClickUpload}>
                     <div className={`input-file-drop-image ${getImage() && 'hide-text'}`} aria-disabled="false">
                        <div className="flex-display" style={{
                           backgroundImage: getImage() ? `url(${getImage()})` : undefined,
                           borderRadius: "15px 15px 0 0"
                        }}>
                           <div className="text-center text-muted">
                              <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="image" className="svg-inline--fa fa-image fa-w-16 fa-2x m-center block-display mb5" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                 <path fill="currentColor"
                                    d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z">
                                 </path>
                              </svg>
                              <span className="text-bigger">Hình ảnh</span>
                           </div>
                        </div>
                        <input
                           accept="image/jpg, image/jpeg, image/png, image/gif"
                           type="file"
                           autoComplete="off"
                           ref={ref}
                           onChange={onChangeFile}
                           style={{ display: 'none' }} />
                     </div>
                  </div>
                  <div className="input-text input-text-none-scrollbar text-multi bold-light border-none shadow-none text-smaller editor">
                     <SlateEditor
                        emoji={true}
                        control={true}
                        maxLength={80}
                        placeholder={'Nhập tiêu đề...'}
                        onChange={onChangeTitle}
                        valueDefault={image.title}
                     />
                  </div>
                  <div className="input-text input-text-none-scrollbar text-multi border-none shadow-none text-smaller editor">
                     <SlateEditor
                        emoji={true}
                        control={true}
                        maxLength={80}
                        placeholder={'Nhập phụ đề...'}
                        onChange={onChangeSubTitle}
                        valueDefault={image.sub_title}
                     />
                  </div>
               </div>
               <div className="card-gallery-item-button-list">
                  {image?.buttons?.map((button, index) => (
                     <Button
                        {...props}
                        button={button}
                        buttons={image?.buttons}
                        key={index}
                        index={index}
                        handleChangeButton={handleChangeButton}
                     />
                  ))}
                  {image?.buttons?.length < 3 &&
                     <div className="button-editor" onClick={handleAddButton}>
                        <span className="pointer text-ellipsis add-more text-center">
                           <div className="button-editor-wrapper">
                              <span className="button-content">
                                 <span className="">+ Thêm nút</span>
                              </span>
                           </div>
                        </span>
                     </div>
                  }
               </div>
            </div>
         </div>
      </div>
   )
}

export default GalleryItem;